import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import { compose } from 'redux';
import { withRouter } from 'react-router';
import { Button } from '@material-ui/core';
import MapIcon from '@material-ui/icons/MapOutlined';
import WorkIcon from '@material-ui/icons/WorkOutlineOutlined';

class PageToggleButtonGroup extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // React router
        match: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
        history: PropTypes.object.isRequired
    };

    constructor (props) {
        super(props);
    }

    changePage = (event, page) => {
        if (page) {
            this.props.history.push(page);
        }
    };

    render () {
        const { classes, match, location } = this.props;
        return location.pathname !== '/map' ? (
            <Button
                className={classes.button}
                startIcon={<MapIcon />}
                variant="outlined"
                onClick={(e) => this.changePage(e, '/map')}
            >
                Map View
            </Button>
        ) : (
            <Button
                className={classes.button}
                startIcon={<WorkIcon />}
                variant="outlined"
                onClick={(e) => this.changePage(e, '/dashboard')}
            >
                Workspace
            </Button>
        );
    }

}

const style = theme => ({
    root: {
        marginLeft: 'auto',
        marginRight: theme.constants.spacing.lg,
        backgroundColor: 'transparent',
        height: '100%'
    },
    button: {
        // height: '100%',
        // border: `1px solid ${theme.palette.grey.variant5}`,
        // borderRadius: 0,
        textTransform: 'none'
        // color: `${theme.palette.grey.variant5} !important`,
        // fontWeight: 'bold',
        // minWidth: '100px',
        // width: '126px'
    },
    selected: {
        border: `1px solid ${theme.palette.grey.variant5}`,
        backgroundColor: `${theme.palette.grey.variant5} !important`,
        color: `${theme.palette.primary.main} !important`
    }
});

export default compose(
    withRouter,
    withStyles(style)
)(PageToggleButtonGroup);